/**
 *  17/01/2019 v 1.0 - JuanMa
 *  v1.1 27/03/2019 Añadido parámetro titulo e id. Asignación dinámica de ids en subcomponentes
 *  v1.2 01/04/2019 Corrección de !=
 *  v1.3 07/05/2019 Nuevo evento onMostrar
 *                  Eliminado mostrar de WillReceiveProps para evitar cierre
 *  v1.4 27/05/2019 Añadido spinner de carga y propiedad cargandoDatos para controlarlo
 *  v1.5 06/06/2019 Añadido botón de borrar
 *  v1.6 01/10/2019 Añadidos classNames en Cols "selectorLista_colEdit" y "selectorLista_colButton"
 *  v1.7 23/10/2019 Añadido onKeyUp para detectar la pulsacion de MAYUS para abrir el dialogo
 *                  Añadida propiedad tabOrderManager
 *                  Añadida propiedad CampoNombre necesaria para la gestión de tabOrderManager
 *  v1.8 25/10/2019 Añadida gestión de onAcceptedRow del grid.
 *  v1.9 04/11/2019 Añadida propiedad datoSelected para tener el elementoSeleccionado Correcto y que se devuleva al aceptar.
 *                  Añadido setFocusSiguiente en método onAceptar
 *                  Añadida comprobación de eexistencia antes de usar las funciones de tabOrderManager
 *  v1.10 18/02/2020 Corregido autocomplete por autoComplete
 *  v1.11 28/05/2020 Añadidas propiedades gridColumnaIdCampo y gridColumnaIdTitulo para mostrar columna inicial con el codigoid
 *  v1.12 20/07/2020 Modificado onSelectedRow para que tome el elemento selecionado del grid que viene en la llamada directamente.
 *                   Si lo tomamos de datos[] falla por no tener en cuenta el filtrado de elementos del grid.
 *
 *
 *
 *  v1.13 28/07/2020 Añadida propiedad columnasAdicionales para añadir columnas a mostrar.
 *                   Añadida logica para mostrar los campos adicionales.
 *  v1.14 08/09/2020 Añadido cálculo dinámicod del style.width en función del número de columnas adicionales.
 *  v.2.0 30/09/2020 Cambiado a framework2
 *  v.2.1 05/10/2020 Añadida propiedad para indicar el tipo de grid.
 *                   Height del diálogo calculado dinamicamente según el tipo de grid.
 *  v.2.2 08/10/2020 En OnAceptar, si no se ha seleccionado ningún elemento se toma el primero.
 *  v.2.3 12/11/2020 Render usando Flex en lugar de container.
 *                   Añadida propiedad mostrarCodigoid para mostrar el codigoid del elemento seleccionado
 *                   Añadida propiedad valorCodigoid para pasar el valor inicial de codigoid
 *                   Añadido en el render mostrar el codigoid.
 *
 *  v.2.4 16/08/2020 Añadida prop inline y className
 *                   Añadida propiedad width para el ancho del texto (InputGroup)
 *                   Sustituido el Container por divs/flex
 *
 *                   ¿ Añadido propiedad para buscar en todas las columnas ?
 * v.2.5 17/08/2020  Añadido style a los dos botones de aceptar y cancelar con marginTop: 10
 * v.2.6 17/02/2021  Cuando es readOnly, no mostramos el botón de borrar.
 * v.2.7 24/03/2021 En Render de GRIDRDG  se ha aplicado estilo={{height: '320px'}}
 * v.2.8 05/04/2021 En <GridRDG utilizamos el evento onRowSelectedReturn y hacemos que apunte a this.onAcceptedRow
 * v.2.9 22/05/2021 Añadida propiedad clickRowEsAceptar, para aceptar elemento al pincharlo.
 *                  En el evento onSelectedRow: Si onSeleccionRowAceptar, llamamos a onAcceptedRow
 *
 * v.2.10 28/06/2021 Añadida la propiedad renderConFormGroup para renderizar con FormGroup (planifikator style)
 * v.2.11 13/07/2021 Modificado el uso de renderConFormGroup para que sea true por defecto
 *
 *
 * v.2.12 05/06/2022 Unión planifikator y sidemur
 * v.2.13 16/06/2022 Añadidas propiedades onAccion y accionIcon
 *                   Modificado el render para mostrar el botón de acción.
 * v.2.14 07/07/2022 Añadida propiedad valorObjetoInicial
 *                   Creada la función onAcción que decide que parametro pasar: datoSelected o valorObjetoInicial
 *                   Modificado onClick de botón de Accion para que vaya a la funcion onAccion
 *
 * v.2.15 04/10/2023 Añadida propiedad onMostrarTexto
 *                   Modificado render para escribir en un div el contenido devuelto por onMostrarTexto
 *                   Modificado render para usar estiloSelectorListaInputReal y diferenciar dos estilos según haya texto adicional o no.
 * v.2.16 19/11/2023 Añadida propiedad classNameTitulo
 *                   Modificada condición renderConFormGroupReal
 *                   En el cálculo de classNameeTituloReal, por defecto se asigna "selectorlista_titulo"
 *
 *                   En Render, en el caso de !renderConFormGroupReal, añadido el Div del texto que viene de onMostrarTexto
 *                   En Render, en el caso de !renderConFormGroupReal, en la condición de mostrar botón de Accion se añade (onAccion && valor)
 *
 * v.2.17 21/11/2023 Modificado el método onEliminar para limpiar datoSelected
 * v.2.18 13/05/2025 En la funcion onKeyPress, comprobar si existe el TabOrder.
 */

 import React from 'react'
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import Grid from "../../blueprint/Grid";
import * as Classes from "@blueprintjs/core/lib/esm/common/classes";
import {Button, Dialog, FormGroup, InputGroup, Intent, Spinner, Tooltip} from "@blueprintjs/core";
import GridRDG from "../../adazzle/GridRDG";
import "../../resources/css/selectorlista.css";



class SelectorLista extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            opened: props.opened ? props.opeed : false,
            titulo: props.titulo,
            id: props.id,
            datos: props.datos ? props.datos : [],
            valor: props.valor ? props.valor : "",
            icon: props.icon,
            cargandoDatos: false,
            gridColumnaCampo: props.gridColumnaCampo ? props.gridColumnaCampo : "",
            gridColumnaTitulo: props.gridColumnaTitulo ? props.gridColumnaTitulo : "",
            gridColumnaIdCampo: props.gridColumnaIdCampo ? props.gridColumnaIdCampo : "",
            gridColumnaIdTitulo: props.gridColumnaIdTitulo ? props.gridColumnaIdTitulo : "",
            //datoSelected: props.datoSelected,
        }
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.datos !== prevState.datos) {
            newState.datos = nextProps.datos;
        }
        if (nextProps.valor !== prevState.valor) {
            newState.valor = nextProps.valor;
        }
        if (nextProps.cargandoDatos !== prevState.cargandoDatos) {
            newState.cargandoDatos = nextProps.cargandoDatos;
        }
        /*
        if (nextProps.datoSelected !== prevState.datoSelected) {
            newState.datoSelected = nextProps.datoSelected;
        }
        */
        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    
    onSelectedRow= (row, elemento) => {
        const{onSeleccionRowAceptar} = this.props;
        //console.log("Selector Lista");
        //console.log(elemento);
        this.setState({datoSelected: elemento});
    }

    onAcceptedRow= (datoAccepted) => {
        //console.log("onACCEPTEDROW");
        if (datoAccepted)
            this.setState({datoSelected: datoAccepted}, ()=> { this.onAceptar()});
        else
            this.onAceptar();
    }

    onCancelar= () => {
        const {tabOrderManager, campoNombre} = this.props;
        if (tabOrderManager)
            tabOrderManager.setFocusSiguiente(campoNombre);  //!!! Importante primero el setFocus y luego el setState.
        this.setState({ opened: false});
    }

    onAceptar= () => {
        const {datos, datoSelected} =  this.state;
        const {OnDatoChanged, tabOrderManager, campoNombre} = this.props;
        let datoSeleccionadoReal= datoSelected;

        if (!datoSelected){
            if (datos.length > 0)
                datoSeleccionadoReal= datos[0];
        }

        if (tabOrderManager)
            tabOrderManager.setFocusSiguiente(campoNombre);  //!!! Importante primero el setFocus y luego el setState.
        this.setState({ opened: false, filtroValor: "", datosFiltrados: datos}); //Todo preparado para la siguiente busqueda
        OnDatoChanged && OnDatoChanged(datoSeleccionadoReal);
    }

    onEliminar= () => {
        console.log("Selectorlista ONELIMINAR <-------------");
        const {OnDatoChanged} = this.props;
        this.setState({valor: "", datoSelected: null});
        OnDatoChanged && OnDatoChanged(null);
    }

    onAccionar= () => {
        const {datoSelected} = this.state;
        const {onAccion, valorObjetoInicial} = this.props;
        //console.log("onAccion");
        //console.log("datoSelected: ",datoSelected);
        //console.log("valorObjetoInicial: ", valorObjetoInicial);
        if (!datoSelected)
            onAccion && onAccion(valorObjetoInicial);
        else
            onAccion && onAccion(datoSelected);
    }



    keyPress= (target) =>{
        const {tabOrderManager, campoNombre} = this.props;
        if(tabOrderManager && target.charCode===13){
            tabOrderManager.setFocusSiguiente(campoNombre);
        }
    }

    keyUp= (event) =>{
        const {onMostrar} = this.props;
        //console.log(event.keyCode);
        //if (event.keyCode === 16){ //MAYUS
        if (event.keyCode === 17){  //CTRL
            onMostrar && onMostrar();
            this.setState({opened: true})
        }
    }

    abrirFormularioElemento= () => {
        const {onAbrirFormularioElemento} = this.props;
        onAbrirFormularioElemento && onAbrirFormularioElemento();
    }

    onCalcularTexto= () => {
        const {datoSelected} = this.state;
        const {onMostrarTexto} = this.props;
        //console.log (">>>>>> OnMostrarTexto <<<<<<<");
        //console.log("datoSelected: ", datoSelected);
        if (datoSelected) {
            //console.log("fonMostrarTexto: ", onMostrarTexto(datoSelected));
            return onMostrarTexto(datoSelected);
        }
        else
            return "";
    }

    render() {
        const {opened, titulo, id, datos,  valor, icon, cargandoDatos, datoSelected,
            gridColumnaCampo, gridColumnaTitulo, gridColumnaIdCampo, gridColumnaIdTitulo} =  this.state;
        const {onMostrar, tabOrderManager, campoNombre, obligatorio, columnasAdicionales, tipoGrid,
            mostrarCodigoid, valorCodigoid,
            ocultarEncabezados, width, readonly,
            clickRowEsAceptar,
            renderConFormGroup,
            onAccion, accionIcon, onAbrirFormularioElemento,
            onMostrarTexto,
            classNameTitulo} = this.props;

        const inputGroupId= "ig" + id;
        const filtroId= "fil" + id;
        let readonlyReal= readonly && Boolean(readonly);
        let columnas = [
            {campo: gridColumnaCampo, titulo: gridColumnaTitulo, tipo: "CADENA", ancho:300},
        ]

        //console.log(" ***** SelectorLista ***** ", titulo);
        //console.log("renderConFormGroup: ", renderConFormGroup);
        //console.log("width: ", width);
        //console.log("onAbrirFormularioElemento: ", onAbrirFormularioElemento);
        //console.log("onAbrirFormularioElemento != undefined: ", onAbrirFormularioElemento != undefined);
        //console.log("valor:");
        //console.log(valor);
        //console.log(columnasAdicionales);
        //console.log("onMostrarTexto: ", onMostrarTexto);

        let style= null;
        if (columnasAdicionales){
            columnasAdicionales.forEach(
                (columnaAdicional) => {
                    columnas.push({campo: columnaAdicional.campo, titulo: columnaAdicional.titulo, tipo:"CADENA", ancho: columnaAdicional.ancho});
                }
            );
            //console.log("size:", columnasAdicionales.length);
            if (columnasAdicionales.length > 0) {
                let width = 40 + (columnasAdicionales.length - 1) * 10;
                style = { width: width + "%"};
            }
        }

        if (gridColumnaIdCampo)
            columnas.unshift({campo: gridColumnaIdCampo, titulo: gridColumnaIdTitulo, tipo: "CADENA", ancho:100});



        //console.log("id: ", id);
        //console.log("onAccion: ", onAccion);
        //console.log("mostrarCodigoid:", mostrarCodigoid);
        //console.log("tipoGrid:", tipoGrid);
        //console.log("DatoSelected:", datoSelected);
        //console.log("datos:", datos);
        //console.log("valor:", valor);
        //console.log("valorCodigoid:", valorCodigoid);
        //console.log ("widthReal: ", widthReal);

        let height=  tipoGrid === "reactdatagrid" ? 350 : 270;
        let tituloReal= obligatorio ?  titulo + "*" : titulo;
        let widthReal= width ? width.toString() + "px" : "200px";
        let renderConFormGroupReal= renderConFormGroup != undefined ? Boolean(renderConFormGroup) : true;

        let valorCodigoidReal= "";
        if (mostrarCodigoid){
            if (datoSelected){
                if (gridColumnaIdCampo)
                    valorCodigoidReal= datoSelected[gridColumnaIdCampo];
                else
                    valorCodigoidReal= datoSelected.codigoid;
            }
            else
                valorCodigoidReal= valorCodigoid;
        }

        let estiloSelectorListaInputReal=  onMostrarTexto ? "selectorlista_input_40" : "selectorlista_input";
        let classNameTituloReal= classNameTitulo ? classNameTitulo : "selectorlista_titulo";
        //console.log("valorCodigoidReal: ", valorCodigoidReal);
        //console.log("tipoGrid:", tipoGrid);
        //console.log("height: ", height);
        //console.log("renderConFormGroupReal: ", renderConFormGroupReal);
        //console.log("classNameTituloReal: ", classNameTituloReal);

        return (
            <div>

                {!Boolean(renderConFormGroupReal) &&
                <div className="selectorlista">
                    <div className={classNameTituloReal}>{tituloReal}</div>
                    <InputGroup
                        disabled={readonlyReal}
                        style={{width: widthReal}}
                        id={inputGroupId}
                        autoComplete="off"
                        leftIcon={icon ? icon : "filter-list"}
                        placeholder={titulo}
                        value={valor ? valor : ""}
                        //readOnly={true}
                        onClick={() => {
                            onMostrar && onMostrar();
                            this.setState({opened: true})
                        }}
                        onKeyPress={this.keyPress}
                        onKeyUp={this.keyUp}
                        inputRef={campoNombre && tabOrderManager ? tabOrderManager.getRef(campoNombre) : null}
                        onChange={() => {
                        }} //Lo ponemos vacío porque tenemos que poner un onChange para que no salte el warning y no queremos que se pueda escribir.
                    />
                    {!readonlyReal &&
                    <Button icon="trash" className="selectorListaBoton" onClick={this.onEliminar}/>
                    }
                    {onAbrirFormularioElemento &&
                    <Button icon="eye-open" className="selectorlista_boton" onClick={this.abrirFormularioElemento}/>
                    }
                    {(onAccion && valor) &&
                    <Button icon={accionIcon} className="selectorlista_boton" onClick={this.onAccion}/>
                    }
                    {mostrarCodigoid &&
                    <div
                        className="selectorlista_codigoid"> {valorCodigoidReal} </div>
                    }
                    {onMostrarTexto &&
                        <div className="selectorlista_texto">{this.onCalcularTexto()}</div>
                    }

                </div>
                }

                {Boolean(renderConFormGroupReal) &&
                <FormGroup
                    label={titulo}
                    labelFor={inputGroupId}  labelInfo={obligatorio ? "*" : ""}>
                    <div className="selectorlista">
                        <div className= {estiloSelectorListaInputReal}>
                            <InputGroup
                                disabled={readonlyReal}
                                //style={{width: widthReal}}
                                id={inputGroupId}
                                autoComplete="off"
                                leftIcon= {icon ? icon : "filter-list" }
                                placeholder={titulo}
                                value={valor ? valor : ""}
                                //readOnly={true}
                                onClick={ () => {
                                    onMostrar && onMostrar();
                                    this.setState({opened: true})
                                } }
                                onKeyPress={this.keyPress}
                                onKeyUp={this.keyUp}
                                inputRef={ campoNombre && tabOrderManager ? tabOrderManager.getRef(campoNombre) : null }
                                onChange={()=> {}} //Lo ponemos vacío porque tenemos que poner un onChange para que no salte el warning y no queremos que se pueda escribir.
                            />
                        </div>
                        {!readonlyReal &&
                        <Button icon="trash" className="selectorlista_boton" onClick={this.onEliminar}/>
                        }
                        {onAbrirFormularioElemento &&
                        <Button icon="eye-open" className="selectorlista_boton" onClick={this.abrirFormularioElemento}/>
                        }
                        {(onAccion && valor) &&
                        <Button icon={accionIcon} className="selectorlista_boton" onClick={this.onAccionar}/>
                        }
                        {mostrarCodigoid &&
                        <div className="selectorlista_codigoid">{valorCodigoidReal} </div>
                        }

                        {onMostrarTexto &&
                        <div className="selectorlista_texto">{onMostrarTexto(datoSelected)}</div>
                        }

                    </div>
                </FormGroup>
                }



                <Dialog
                    icon="info-sign"
                    onClose={this.onCancelar}
                    title= {"Selección"}
                    isOpen={opened}
                    usePortal= {true}
                    canOutsideClickClose={false}
                    style={ style }
                    autofocus={true}
                >
                    <div className={Classes.DIALOG_BODY} style={{height:height}}>
                        { cargandoDatos && <Spinner intent={Intent.PRIMARY} size={50} /> }
                        { (!cargandoDatos && tipoGrid !== "reactdatagrid") &&
                        <Grid columnas={columnas} datos={datos}
                              onSelectedRow={this.onSelectedRow}
                              onAcceptedRow={this.onAcceptedRow}
                              ordenable={false}
                              estilo={{height: '230px'}}
                              mostrarEncabezado={false}
                              elementoSeleccionado={datoSelected}
                              ocultarEncabezados={ocultarEncabezados}
                        />
                        }
                        { (!cargandoDatos && tipoGrid === "reactdatagrid") &&
                        <GridRDG estilo={{height: '320px'}}
                                 columnas={columnas} datos={datos}
                                 onSelectedRow={this.onSelectedRow}
                                 ordenable={true}
                                 //showBuscador={true}
                                 //ref={this.refGrid}
                                 mostrarChecksSeleccion={false}
                                 rowKey={"codigo"}
                                 mostrarHeaderRow={!ocultarEncabezados}
                                 onRowSelectedReturn={ this.onAcceptedRow}
                                 rowClickedIsReturn={clickRowEsAceptar}
                        />
                        }
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Tooltip content="Aceptar">
                                <Button style={{marginTop: 10}} intent={Intent.SUCCESS} icon="tick-circle" onClick={this.onAceptar}>Aceptar</Button>
                            </Tooltip>
                            <Tooltip content="Cancelar">
                                <Button style={{marginTop: 10}} intent={Intent.DANGER} icon="delete" onClick={this.onCancelar}>Cancelar</Button>
                            </Tooltip>
                        </div>
                    </div>
                </Dialog>
            </div>



        );
    }
}


SelectorLista.propTypes = {
    datos: PropTypes.array.isRequired,
    valor: PropTypes.any,
    icon: PropTypes.string,
    onMostrar: PropTypes.func,
    tabOrderManager: PropTypes.object,
    campoNombre: PropTypes.string,
    gridColumnaCampo: PropTypes.string,
    gridColumnaTitulo: PropTypes.string,
    gridColumnaIdCampo: PropTypes.string,
    gridColumnaIdTitulo: PropTypes.string,
    datoSelected: PropTypes.object,
    obligatorio: PropTypes.bool,

    columnasAdicionales: PropTypes.array,
    tipoGrid: PropTypes.string,
    mostrarCodigoid: PropTypes.bool,
    valorCodigoid: PropTypes.string,

    inline: PropTypes.bool,
    className: PropTypes.string,
    ocultarEncabezados: PropTypes.bool,
    width: PropTypes.number,
    readonly: PropTypes.bool,
    clickRowEsAceptar: PropTypes.bool,
    renderConFormGroup: PropTypes.bool,

    onAccion: PropTypes.func,
    accionIcon: PropTypes.string,
    onAbrirFormularioElemento: PropTypes.func,

    valorObjetoInicial: PropTypes.object,
    onMostrarTexto: PropTypes.func,

    classNameTitulo: PropTypes.string,
}

export default SelectorLista

